export default function WebhooksCircle() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#18181B" />
      <path
        d="M12 6V6.5M12 6V6.5M8.5 7.5L8.85355 7.85355M15.5 7.5L15.1464 7.85355M6 12H6.5M17.5 12H18M8.5 16.5L8.85355 16.1464M15.5 16.5L15.1464 16.1464M12 17.5V18M12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5Z"
        stroke="#A1A1AA"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="17" cy="7" r="2" fill="#A9D342" />
    </svg>
  );
}
